module.exports = __webpack_public_path__ + "static/media/next-arrow.d049e16e.svg";